/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';

import { LeadBoardBusinessService } from '../../../../../resources/lead-board-business.service';
import { LeadBoardCardMoveDialogComponent } from './lead-board-card-move-dialog.component';

export const createLeadBoardCardMoveDialog = createDialogRoute({
  component: LeadBoardCardMoveDialogComponent,
  init: LeadBoardBusinessService,
  config: {
    maxHeight: '100vh',
    maxWidth: '90vw',
  },
});
